import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import Atricon from './atric';
import '../../styles/itens.scss';
import { Link } from 'react-router-dom';

async function getItens() {
    let response = await fetch('https://prefeituramacuco.rj.gov.br/transparencia/api/atricon.json')
    let data = await response.json()
    return data
}


const Atricons = () => {


    const sectionTitles = {
        '1': 'Informações Prioritárias',
        '2': 'Informações Institucionais',
        '3': 'Receita',
        '4': 'Despesa',
        '5': 'Convênios e Transferências',
        '6': 'Recursos Humanos',
        '7': 'Diárias',
        '8': 'Licitações',
        '9': 'Contratos',
        '10': 'Obras',
        '11': 'Planejamento e Prestação de Contas',
        '12': 'SIC',
        '13': 'Acessibilidade',
        '14': 'Ouvidoria',
        '15': 'LGPD e Governo Digital',
        '16': 'Renúncia de Receita',
        '17': 'Emendas Parlamentares',
        '18': 'Saúde',
        '19': 'Educação'
    };

    const [itens, setItens] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        getItens().then(data => {
            setItens(data['itens'])
        })
    }, [])

    const filteredItens = itens.filter(item => item.titulo.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <Fragment>
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1}>
                    <Col xs={{ span: 4, offset: 4 }}>
                        <Form.Group>
                            <Form.Control
                                type="text"
                                placeholder="Pesquise"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <br />
                <Row xs={1}>
                    {filteredItens.map((item, index) => {
                        const sectionNumber = item.titulo.split('.')[0];
                        const isNewSection = item.titulo.split('.')[1].charAt(0) === "1" ? true : false;
                        const sectionTitle = sectionTitles[sectionNumber];
                        return (
                            <Col key={index}>
                                {isNewSection ? <Fragment><br/><h4 style={{ textAlign: 'center' }}>{sectionTitle}</h4></Fragment> : null}
                                <Atricon
                                    titulo={item.titulo}
                                    descricao={item.descricao}
                                    link={item.link}
                                />
                            </Col>
                        );
                    })}
                </Row>
            </Container>
        </Fragment>
    )

}

export default Atricons;